import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'sap-root',
	templateUrl: './app.component.html'
})

export class AppComponent {

	constructor () {}
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts